/**
 * How a real element becomes a tour target. A step names a target; the UI it
 * points at carries `data-tour="<name>"`. Never a class name, a label or a
 * position, which all change without anyone thinking of the tour. (The shell's
 * own `data-shell-*` hooks, `config/shellHooks.js`, are the same idea for the
 * pieces the shell draws; a tour target for one of those is a `data-tour` set
 * beside it.)
 *
 *   <Button {...tourTargetProps('add-item')}>Add item</Button>
 */
export const TOUR_ATTRIBUTE = 'data-tour';

/** Spread onto an element to make it a target. */
export const tourTargetProps = (name) => ({ [TOUR_ATTRIBUTE]: name });

/** The CSS selector for a target name. Names are plain words, never user data. */
export const tourSelector = (name) => `[${TOUR_ATTRIBUTE}="${String(name).replace(/["\\]/g, '')}"]`;
